import { MdBlock } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { Card, CardBody, CardTitle } from "reactstrap";

const Unauthorized = () => {
  const navigate = useNavigate();
  return (
    <div className="d-flex justify-content-center mt-5 mb-auto">
      <Card className="mt-5 p-5">
        <CardTitle>
          <h1> Unauthorized </h1>
        </CardTitle>
        <CardBody>
          <div style={{ textAlign: "center" }}>
            <MdBlock color="red" size={50} />
          </div>
          <div style={{ textAlign: "center" }}>
            <Link to="/">Try login again</Link>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default Unauthorized;
